import HotTable from "react-handsontable"
import * as React from "react"
import { injectIntl, InjectedIntlProps } from "react-intl"
import { CardModal, CardModalNotOkButton } from "../../../modal"
import { Demography, LocalAuthority } from "../../../../model"

class ViewDemographiesModalComponent
extends React.Component<ViewDemographiesModalProps & InjectedIntlProps> {
	private readonly DATA_ROW_KEYS = Object.keys({ year: null, population: null } as DataRow)

	render() {
		return (
			<CardModal active
			           onClickCloseButton={e => { this.props.onClickCloseButton(e) }}
			           onClickFooterButton={(b, e) => { this.props.onClickFooterButton(b, e) }}
			           onSubmit={e => { e.preventDefault(); this.props.onClickCloseButton(e) }}
			           paddingLess
			           title="Population">
				<HotTable afterChange={(c, s) => { this.props.onChange(c, s) }}
				          autoInsertRow={true}
				          colHeaders={["Année", "Population"]}
				          columns={this.getHotColumns()}
				          data={this.props.data}
				          height={320}
				          stretchH="all" />
			</CardModal>
		)
	}

	private getHotColumns() {
		const commonProps = this.props.consulted
		? {
			language: "fr-FR",
			type    : "numeric",
			readOnly: true
		}
		: {
			language: "fr-FR",
			type    : "numeric"
		}
		return [
			{
				...commonProps,
				data: this.DATA_ROW_KEYS[0],
			},
			{
				...commonProps,
				format: "0,0",
				data  : this.DATA_ROW_KEYS[1],
			}
		]
	}
}

export default injectIntl(ViewDemographiesModalComponent)

export interface ViewDemographiesModalProps {
	consulted: boolean
	data: DataRow[]
	localAuthority: LocalAuthority
	onChange(changes: any[][], source: string): void
	onClickCloseButton(event: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
}

export interface DataRow extends Demography {

}



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/view-demographies-modal/view-demographies-modal-component.tsx